import GameIcon from '@/assets/svg/icon/game.svg';
import SpinIcon from '@/assets/svg/icon/spin.svg';
import HomeIcon from '@/assets/svg/icon/home.svg';
import FriendIcon from '@/assets/svg/icon/friends.svg';
import BonusIcon from '@/assets/svg/icon/bonus.svg';
import DropIcon from '@/assets/svg/icon/bc-drop.svg';
import newTag from '@/assets/images/airdrop/new-tag.png'
import { For } from 'solid-js';
import { A } from '@solidjs/router';
import { t } from '@/i18n';
import ChristmasSrc from '@/assets/images/event/bar2.png';
import ChristmasBgSrc from '@/assets/images/event/bar-bg.png';
import luckyRaffleIcon from '@/assets/images/luckyRaffle/lucky-raffle.png';

const TabBar = () => {
  const tabConfig = [
    { name: 'Main', icon: <HomeIcon />, link: '/', end: true },
    // { name: 'Spin', icon: <SpinIcon />, link: '/spin', end: true },
    { name: 'Friends', icon: <FriendIcon />, link: '/friends', end: false },
    // { name: 'Christmas', icon: <GameIcon />, link: '/event/christmas', end: false },
    { name: 'Raffle', icon: <GameIcon />, link: '/event/raffle', end: false },
    { name: 'BC.GAME', icon: <GameIcon />, link: '/games', end: true },
    { name: 'BCdrop', icon: <DropIcon />, link: '/airdrop', end: true },
  ];
  return (
    <div class="fixed inset-x-3 bottom-5 z-90 flex items-center rounded-2xl bg-layer6 p-1.5 font-extrabold bottom-nav">
      <For each={tabConfig}>
        {(item) => {

          if (item.name === 'Raffle') {
            return <A
              href={item.link}
              end={item.end}
              class="center flex-[1.4] flex-col text-[#B9B9B9] -mt-6 bg-layer6 rounded-full pb-[0.6rem]"
              activeClass="text-primary !bg-[#242424]"
              onClick={() => {
                document.body.scrollTo(0, 0);
              }}
            >
              <img class="w-full mt-2 mr-2" src={luckyRaffleIcon} alt=""/>
            </A>
          }

          if (item.name === 'BCdrop') {
            return (
              <A
                href={item.link}
                end={item.end}
                class="center flex-1 flex-col rounded-xl py-2 text-[#B9B9B9] relative"
                activeClass="bg-[#242424] text-primary"
                onClick={() => {
                  document.body.scrollTo(0, 0);
                }}
              >
                <img src={newTag} class="absolute w-8 object-contain top-1 right-1"></img>
                <div class="mb-1 size-7">{item.icon}</div>
                <div class="text-xs">{t(item.name)}</div>
              </A>
            )
          }

          return (
            <A
              href={item.link}
              end={item.end}
              class="center flex-1 flex-col rounded-xl py-2 text-[#B9B9B9]"
              activeClass="bg-[#242424] text-primary"
              onClick={() => {
                document.body.scrollTo(0, 0);
              }}
            >
              <div class="mb-1 size-7">{item.icon}</div>
              <div class="text-xs">{t(item.name)}</div>
            </A>
          );
        }}
      </For>
    </div>
  );
};

export default TabBar;
